.root {
  position: relative;
  display: inline-flex;
  align-items: center;
  width: 32px;
  height: 18px;
  padding: 0;
  border: 0;
  border-radius: 32px;
  background-color: var(--surface-neutral);
  cursor: pointer;
  transition: background-color 120ms ease;
}

.root:focus-visible {
  outline: 1px solid var(--border-focus);
  outline-offset: 1px;
}

.root.checked {
  background-color: var(--surface-primary);
}

.root.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.circle {
  position: absolute;
  left: 2px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: var(--surface-white, #fff);
  transition: transform 120ms ease;
  transform: translateX(0);
}

.circle.circleChecked {
  transform: translateX(14px);
}
